/**
 * Utilities for bucketing visitors
 * @module
 */

var hashing = require('optimizely-hashing');

var TOTAL_POINTS = exports.TOTAL_POINTS = 10000;

/**
 * Generate a "bucketingNumber" which is a hash based on the ticket, entityId, and seed
 * Designed to be consistent with consistent inputs.
 * @param {string} bucketingId
 * @param {string} entityId
 * @param {number} seed hashing.Seed
 * @return {number} between 0 and 9999 representing the bucketing number for the ticket
 * @private
 */
exports.bucketingNumber = function(bucketingId:string, entityId:string, seed:number): number {
  var result = hashing.hashToInt(bucketingId + entityId, seed, TOTAL_POINTS);
  return result;
};

/**
 * Decide if this ticket should be withheld from a given "entity" (layer, experiment, variation, etc)
 * based on the entity holdback property.
 * @param {string} bucketingId
 * @param {Object} entity
 * @param {string} entity.id
 * @param {number} entity.holdback
 * @return {boolean} if the ticket should be held back
 */
exports.isHoldback = function(bucketingId:string, entity:any): boolean {
  return exports.bucketingNumber(bucketingId, entity.id, hashing.Seed.IGNORING) < (entity.holdback || 0);
};

/**
 * Choose a weight for a ticket from an array of possible weights based on the entity
 * @param {string} bucketingId
 * @param {string} parentId
 * @param {WeightDistribution[]} candidates
 * @return {string} id of the chosen candidate
 */
exports.chooseWeightedCandidate = function(bucketingId:string, parentId:string, candidates:WeightDistribution[]): string {
  var ticketNumber = exports.bucketingNumber(bucketingId, parentId, hashing.Seed.BUCKETING);
  for (var i = 0; i < candidates.length; i++) {
    if (candidates[i].endOfRange > ticketNumber) {
      return candidates[i].entityId;
    }
  }

  throw new Error('Unable to choose candidate');
};
